import { render, staticRenderFns } from "./deviceMsg.vue?vue&type=template&id=701fa800&scoped=true"
import script from "./deviceMsg.vue?vue&type=script&lang=js"
export * from "./deviceMsg.vue?vue&type=script&lang=js"
import style0 from "./deviceMsg.vue?vue&type=style&index=0&id=701fa800&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701fa800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701fa800')) {
      api.createRecord('701fa800', component.options)
    } else {
      api.reload('701fa800', component.options)
    }
    module.hot.accept("./deviceMsg.vue?vue&type=template&id=701fa800&scoped=true", function () {
      api.rerender('701fa800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/deviceMsg.vue"
export default component.exports